import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeDeleteConfirm,
  deleteRow,
  selectDeletingRowId,
  selectLoading
} from '../../features/adminSlice';

const AdminDeleteConfirm = ({ tableName, primaryKeys }) => {
  const dispatch = useDispatch();
  const deletingRowId = useSelector(selectDeletingRowId);
  const loading = useSelector(selectLoading);

  // Format primary key display from comma-separated rowId
  const formatRowIdDisplay = () => {
    if (!deletingRowId) return '';
    const values = String(deletingRowId).split(',');
    return primaryKeys.map((pk, i) => `${pk}: ${values[i]}`).join(', ');
  };

  const handleConfirm = () => {
    dispatch(deleteRow({
      tableName,
      rowId: deletingRowId
    }));
  };

  const handleCancel = () => {
    dispatch(closeDeleteConfirm());
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
      <div className="bg-[#111827] rounded-lg border border-gray-800 w-full max-w-md overflow-hidden">
        {/* Modal Header */}
        <div className="px-6 py-4 border-b border-gray-800">
          <h3 className="text-lg font-semibold text-white flex items-center gap-3">
            <span className="material-icons text-red-500">warning</span>
            Confirm Delete
          </h3>
        </div>

        {/* Modal Body */}
        <div className="px-6 py-6">
          <p className="text-gray-300">
            Are you sure you want to delete this row from <span className="font-semibold text-white">{tableName}</span>?
          </p>
          <p className="text-gray-400 text-sm mt-2">
            Row: <span className="font-mono text-white">{formatRowIdDisplay()}</span>
          </p>
          <p className="text-red-400 text-sm mt-4">
            This action cannot be undone.
          </p>
        </div>

        {/* Modal Footer */}
        <div className="px-6 py-4 border-t border-gray-800 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={handleCancel}
            disabled={loading}
            className="px-4 py-2 text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={loading}
            className="px-4 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 flex items-center gap-2"
          >
            {loading && (
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            )}
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminDeleteConfirm;
